import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppFloat from "./WhatsAppFloat";
import AIChatWidget from "./AIChatWidget";
import { useCustomerTheme } from "../lib/theme";

const CustomerLayout = () => {
  const { theme, toggleTheme } = useCustomerTheme();
  const location = useLocation();
  return (
    <div className="customer-site min-h-screen flex flex-col bg-[#F7F6F3]" data-theme={theme} data-testid="customer-site-root">
      <Header theme={theme} toggleTheme={toggleTheme} />
      <main key={location.pathname} className="flex-1 pt-20 ab-fade-up">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFloat />
      <AIChatWidget />
    </div>
  );
};

export default CustomerLayout;
